import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, Sparkles, Users, Heart, Trees } from 'lucide-react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { PageHero, SectionHeading } from '../components/PageBits';
import { Button } from '../components/ui/button';
import { mockData } from '../data/mock';

const About = () => (
  <div className="min-h-screen bg-cream">
    <Nav transparent />
    <PageHero
      eyebrow="Our Story"
      title="About Queensland Ranch"
      subtitle="A family-owned private estate serving El Paso and Southern New Mexico."
      image="/hero/hero-main.jpg"
    />

    {/* Property overview */}
    <section className="py-20 bg-cream texture-linen">
      <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center max-w-6xl">
        <div className="rounded-lg overflow-hidden shadow-2xl border border-gold/20">
          <img src={mockData.venue.image} alt="Queensland Ranch" className="w-full h-full object-cover" />
        </div>
        <div>
          <p className="text-gold text-sm tracking-[0.3em] uppercase mb-3">The Estate</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy mb-4">
            A Private <span className="text-gold italic">7-Acre</span> Sanctuary
          </h2>
          <div className="h-px w-20 bg-gold mb-6" />
          <p className="text-slate-700 leading-relaxed mb-6">{mockData.venue.description}</p>
          <ul className="space-y-3">
            {[
              { icon: MapPin, label: '5155 NM-28, Anthony, New Mexico' },
              { icon: Trees, label: '7 private acres of mature landscaping' },
              { icon: Sparkles, label: 'Mediterranean architecture with terracotta roofing' },
              { icon: Users, label: 'Accommodates up to 130 guests' },
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3">
                <item.icon className="h-5 w-5 text-gold mt-0.5 flex-shrink-0" />
                <span className="text-navy">{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>

    {/* Family bio */}
    <section className="py-24 bg-ivory texture-linen relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.04]">
        <span className="font-serif text-[26rem] text-navy leading-none select-none">QR</span>
      </div>
      <div className="container mx-auto px-6 relative z-10 max-w-3xl text-center">
        <p className="text-gold text-sm tracking-[0.3em] uppercase mb-3">The Amato Family</p>
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-navy mb-4">
          A Family <span className="text-gold italic">Legacy</span> of Celebration
        </h2>
        <div className="flex items-center justify-center gap-3 mb-10">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold" />
          <div className="w-1.5 h-1.5 rotate-45 bg-gold" />
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold" />
        </div>
        <div className="space-y-6 text-slate-700 text-lg leading-relaxed">
          {mockData.venue.bio.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <p
          className="mt-10 font-serif italic text-gold text-lg tracking-wide"
          dangerouslySetInnerHTML={{ __html: mockData.venue.bio.signature }}
        />
        <div className="mt-10">
          <Link to="/contact">
            <Button size="lg" className="bg-navy hover:bg-navy/90 text-gold border border-gold/60 px-10 py-6 shadow-lg">
              <Calendar className="mr-2 h-5 w-5" />Schedule a Tour
            </Button>
          </Link>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default About;
